module.exports = __webpack_public_path__ + "img/card_ip_stipulation44.51a5b52f.svg";